import { useCallback } from "react";
import { useLingui } from "@lingui/react";
import { useErrorToast } from "../showToast";
import AuthController from "../../controllers/AuthController";
import { Errors } from "../../errors";
import {
  AUTH_CHANGE_PASSWORD_FAILED_TEXT,
  UNEXPECTED_ERROR_TEXT,
} from "../constants/i18n-strings";

export function useChangePassword(handleErrors: boolean) {
  const showErrorToast = useErrorToast();
  const { _: i18n } = useLingui();

  const displayChangeError = useCallback(
    (message: string) => {
      if (message.includes(Errors.ChangePasswordFailed)) {
        showErrorToast(i18n(AUTH_CHANGE_PASSWORD_FAILED_TEXT));
      } else {
        showErrorToast(message);
      }
    },
    [showErrorToast, i18n]
  );

  const changePw = useCallback(
    async (oldPassword: string, password: string, passwordConfirm: string) => {
      try {
        const email = await AuthController.changePassword({
          oldPassword,
          password,
          passwordConfirm,
        });
        return email;
      } catch (e) {
        if (!handleErrors) throw e;

        if (e instanceof Error) {
          displayChangeError(e.message);
        } else {
          showErrorToast(i18n(UNEXPECTED_ERROR_TEXT));
        }
        return "";
      }
    },
    [showErrorToast, displayChangeError, handleErrors, i18n]
  );

  return { changePw, displayChangeError };
}
